// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cDPe","comment":"styles_comment__1oHkT"};